var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWink(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 87 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.5024 4.7417H30.1288L33.0248 16.2745C33.0248 16.2745 33.3389 17.605 33.4691 18.2588C33.5994 17.6076 33.9135 16.249 33.9135 16.249L36.8886 4.7417H40.4383L43.4135 16.249C43.4135 16.249 43.7276 17.605 43.8578 18.2588C43.9881 17.6076 44.3022 16.2745 44.3022 16.2745L47.1982 4.7417H50.8245L45.7885 23.0062H42.083L38.666 9.75218L35.2491 23.0062H31.5436L26.5024 4.7417Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M56.2056 10.064H52.9189V23.0065H56.2056V10.064Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M68.4351 23.0064V15.5443C68.4351 13.8486 67.6255 12.7786 65.7996 12.7786C64.0784 12.7786 62.7989 14.2649 62.7989 16.4305V23.0064H59.5122V10.064H62.7989V12.1504C63.7642 10.6641 65.3042 9.69873 67.1812 9.69873C69.9469 9.69873 71.7218 11.4992 71.7218 14.1857V23.0039H68.4351V23.0064Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M74.6743 4.7417H77.9609V13.9787L81.9014 10.0638H85.9721L81.2502 14.681L86.6003 23.0037H82.8157L78.9544 16.9513L77.9635 17.9166V23.0037H74.6768V4.7417H74.6743Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M52.4819 3.4061L53.7664 4.69064L52.4819 5.97518L54.0014 7.49212L56.8029 4.69064L54.0014 1.88916L52.4819 3.4061Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.76567 0.428711L0.428711 7.76567L6.6369 13.9738L0.428711 20.1846L7.76567 27.5216L21.3134 13.9738L7.76567 0.428711Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWink);
export default __webpack_public_path__ + "static/media/wink.520b06fd.svg";
export { ForwardRef as ReactComponent };